export const religiousBeliefs = ((chart) => {
    const placeHolderText = `${chart.LIVING_WILL.religion}: ${chart.LIVING_WILL.religiousInfo}`
    return placeHolderText
})